import React from 'react'; //eslint-disable-line
import { Link, /*useLocation*/ } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import goTrackerConfig from 'goTrackerConfig';
import BoltIcon from '../components/BoltIcon';
import utils from '../utils';
import '../i18n';
import Logo from '../components/Logo';
import BusLogo from '../components/BusLogo';
import Tags from './Tags';

const getIcon = serviceType => {
  if (serviceType === 'B') return <BusLogo />;

  return <Logo />;
};

const UnionDepartureRows = props => {
  const { t } = useTranslation();
  const { trips, onGetPath, isTwentyFourHour, isLanguageFrench, onResetTripDetail } = props;
  const stationName = props.stationName ? props.stationName : '';

  const resetTripDetail = () => {
    if (onResetTripDetail) {
      onResetTripDetail();
    }
  };

  const getPath = trip => {
    if (onGetPath) {
      return onGetPath(trip);
    }
    return {};
  };

  if (trips.length < 1) {
    return (
      <ul>
        <li className="departure-row no-trip">{`${t('noData')} ${stationName}`}</li>
      </ul>
    );
  }

  return (
    <ul>
      {trips.map((trip, i) => {
        const ariaLive = i === 0 ? 'assertive' : 'off';

        if (trip.stops.length < 1) return;

        return (
          <li className="departure-row" aria-live={ariaLive} key={trip.number}>
            <Link to={() => getPath(trip)} onClick={resetTripDetail}>
              <div className="data in-service union">
                <div aria-describedby={t('unionDepartures.columnHeadings.1')}>
                  <div className="icons">
                    {getIcon(trip.serviceType)}
                  </div>
                  <div>
                    {trip.stops[trip.stops.length - 1].name} {goTrackerConfig.debug === true ? <div className="debug-container trip-number">{trip.number}</div> : ''}
                  </div>
                </div>
                <div className="schedule-col" aria-describedby={t('unionDepartures.columnHeadings.2')}>
                  {utils.formatTime(trip.time, isTwentyFourHour)}
                  {trip.isExpress ? (
                    <span>
                      <BoltIcon />
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                {/* <div className={`equipment ${trip.overallThreshold}`}>{getOccupancyImg(trip.overallThreshold)}</div> */}
                <div className="schedule-col platform" aria-describedby={t('unionDepartures.columnHeadings.3')}>{trip.platform}</div>
                <div aria-describedby={t('unionDepartures.columnHeadings.4')}>
                  {utils.formatTripInfo(trip.info, isLanguageFrench)}
                  <i className="fa fa-chevron-right" />
                </div>
              </div>
              <Tags trip={trip} />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default UnionDepartureRows;
